"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class EnvUtils {
    constructor(options) {
        this.prefix = (options === null || options === void 0 ? void 0 : options.prefix) || '';
        this.envObject = (options === null || options === void 0 ? void 0 : options.envObject) || process.env;
    }
    getValue(config) {
        config.name = this.prefix + config.name;
        const value = this.envObject[config.name];
        if (value) {
            return EnvUtils.translateValue(value, config);
        }
        const defaultValue = EnvUtils.getDefaultValue(config.defaults);
        if (defaultValue !== undefined) {
            return defaultValue;
        }
        else if (config.optional) {
            return undefined;
        }
        else {
            throw Error(`Required env variable ${config.name} not defined, and no default available for NODE_ENV=${process.env.NODE_ENV}`);
        }
    }
    static getDefaultValue(defaults) {
        if (!defaults) {
            return undefined;
        }
        const nodeEnv = process.env.NODE_ENV;
        // If no NODE_ENV set
        if (!nodeEnv) {
            // Return default of any env, might be undefined
            return defaults['*'];
        }
        // Return the default of a specific NODE_ENV
        if (defaults[nodeEnv]) {
            return defaults[nodeEnv];
        }
        // Check if NODE_ENV within a comma-separated envName, e.g. NODE_ENV="test", envName is "prod,test,dev"
        for (const envName of Object.keys(defaults)) {
            if (envName.split(',').includes(nodeEnv)) {
                return defaults[envName];
            }
        }
        return defaults['*'];
    }
    static translateValue(value, config) {
        if (!config.translator) {
            return value;
        }
        if (typeof config.translator === 'function') {
            return config.translator(value);
        }
        switch (config.translator) {
            case 'array':
                return value.split(',');
            case 'boolean':
                return (value === '1');
            case 'float':
                const float = parseFloat(value);
                if (isNaN(float)) {
                    throw Error(`${config.name} could not be parsed to integer`);
                }
                return float;
            case 'integer':
                const integer = parseInt(value, 10);
                if (isNaN(integer)) {
                    throw Error(`${config.name} could not be parsed to integer`);
                }
                return integer;
            default:
                throw Error('Invalid translator provided for ' + config.name);
        }
    }
}
exports.default = EnvUtils;
/**
 *  Returns a value from an env variable by it's name, or throws error if undefined and no default value is applicable
 *
 *  If type of testDefault is number, it tries to parse the env variable to integer
 *  If type of testDefault is boolean, returns true if value is '1', otherwise false.
 *  If type of testDefault is string, returns the env value as is.
 *  Throws if type is none of the above.
 *
 * @deprecated Use EnvUtils.getValue instead
 * @param envVarName the env variable name.
 * @param testDefault the default value when NODE_ENV is test.
 * @param devDefault the default value when NODE_ENV is development. Defaults to testDefault.
 * @param prodDefault the default value when NODE_ENV is production, optional
 * @param err the error thrown if the env variable is undefined, and no default values are applicable.
 */
function getEnvValue(envVarName, testDefault, devDefault = testDefault, prodDefault, err) {
    const envVarValue = process.env[envVarName];
    const NODE_ENV = process.env.NODE_ENV;
    // Check for string value 'undefined', in case env variable is set to undefined in process.env
    if (envVarValue !== undefined && envVarValue !== 'undefined') {
        if (typeof testDefault === 'number') {
            const intVal = parseInt(envVarValue, 10);
            if (!isNaN(intVal)) {
                return intVal;
            }
            else {
                throw Error(`Type of default value is number, but ${envVarName} value ${envVarValue} could not be parsed to integer`);
            }
        }
        else if (typeof testDefault === 'boolean') {
            if (envVarValue === '0' || envVarValue === '1') {
                return (envVarValue === '1');
            }
            else {
                throw Error(`Type of default value is boolean, but ${envVarName} is not '0' or '1', actual value ${envVarValue}`);
            }
        }
        else if (typeof testDefault === 'string') {
            return envVarValue;
        }
        else {
            throw Error(`Type of default value not recognized, getEnvValue called incorrectly with env variable name ${envVarName}`);
        }
    }
    else if (NODE_ENV === 'test') {
        return testDefault;
    }
    else if (NODE_ENV === 'development') {
        return devDefault;
    }
    else if (NODE_ENV === 'production' && prodDefault !== undefined) {
        return prodDefault;
    }
    else {
        throw (err ||
            Error(`${envVarName} not defined, and no default value was applicable in NODE_ENV ${NODE_ENV}`));
    }
}
exports.getEnvValue = getEnvValue;
//# sourceMappingURL=index.js.map